// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1TjPc","row":"ProcedureTreatmentSummary_row__3rt2K"};